type GetToken = () => Promise<string>

const getSignedImageUrl = async (protectedUrl: string, getToken: GetToken) => {
  const token = await getToken()

  return fetch(protectedUrl, { headers: { Authorization: `Bearer ${token}` } }).then((response) => response.blob())
}

export { getSignedImageUrl }
